import { render, staticRenderFns } from "./DialogChart.vue?vue&type=template&id=068a3f58&"
import script from "./DialogChart.vue?vue&type=script&lang=ts&"
export * from "./DialogChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports